var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.364,
    height: 60.364,
    viewBox: "0 0 60.364 60.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5599",
    "data-name": "Group 5599",
    transform: "translate(-530 -3854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Receipt",
    transform: "translate(530 3854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M0,0H60.364V60.364H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    d: "M13.354,50.292a5.388,5.388,0,0,0,1.718-3.58A6.013,6.013,0,0,0,13,42.684a1.207,1.207,0,0,1,.865-2.05H41.633V4.953l-7.965,3a1.207,1.207,0,0,1-.846,0L23.531,4.5l-9.056,3.48a1.207,1.207,0,0,1-.853.005L5.415,4.943V44.256a6.036,6.036,0,0,0,6.036,6.036Zm31.9,2.415h-33.8A8.451,8.451,0,0,1,3,44.256V3.208A1.207,1.207,0,0,1,4.627,2.076l9.407,3.486,9.056-3.48a1.207,1.207,0,0,1,.854,0l9.3,3.457,9.175-3.455a1.207,1.207,0,0,1,1.633,1.13V40.634h1.207a6.036,6.036,0,0,1,0,12.073ZM17.487,46.712a6.726,6.726,0,0,1-1.094,3.58H45.255a3.622,3.622,0,0,0,0-7.244H16.361A6.915,6.915,0,0,1,17.487,46.712Z",
    transform: "translate(4.244 2.829)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    "data-name": "path",
    d: "M27.524,18.659a1.207,1.207,0,0,1,0,2.415H8.207a1.207,1.207,0,0,1,0-2.415ZM17.865,9a1.207,1.207,0,1,1,0,2.415H8.207A1.207,1.207,0,0,1,8.207,9Z",
    transform: "translate(9.902 12.732)",
    fill: "#fd9926",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    "data-name": "path",
    d: "M45.255,52.707h-33.8A8.451,8.451,0,0,1,3,44.256V3.208A1.207,1.207,0,0,1,4.627,2.076l9.407,3.486,9.056-3.48a1.207,1.207,0,0,1,.854,0l9.3,3.457,9.175-3.455a1.207,1.207,0,0,1,1.633,1.13V40.634h1.207a6.036,6.036,0,0,1,0,12.073Z",
    transform: "translate(537.33 3858.829)",
    fill: "#fe9920",
    opacity: 0.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.c6f59ebb5b29154a6cd68849b288b01d.svg";
export { ForwardRef as ReactComponent };